// The client profile's ✕ on one weekly time (Session Tracker card).
//
// Moved out of app.js unchanged on 2026-10-05 (the standing rule: extract from
// app.js what you touch, with the move and the change as separate commits).
// app.js still assigns it to `window.removeStandingSlot`, which is what the
// card's button calls (modules/sessions.js renderSessionCard).

import { callFunction } from './api.js';
import { showToast } from './utils.js';
import { showConfirmDialog } from './modals.js';
import { renderCurrentView } from './navigation.js';
import { clients } from './state.js';
import { clientStandingSlots } from './coach-calendar/held-ghosts.js';
import { slotLabel as standingSlotLabel } from './coach-calendar/standing-slots-dialog.js';

/**
 * Ask, then remove one weekly time from a client.
 * @param {string} clientId
 * @param {string} slotId
 */
export function removeStandingSlot(clientId, slotId) {
  const c = clients.find(x => x.id === clientId);
  const sr = clientStandingSlots(c).find(s => s.id === slotId);
  const label = sr ? standingSlotLabel(sr.dow, sr.time) : 'this standing slot';
  // ⚠️ ON THE NEW SESSION RULES THE WEEKLY TIME IS ITS SESSIONS (sessions v2,
  // part 3): removing it takes them off from today, and the client gets one
  // message. Saying they stay on the calendar would be false.
  const newRules = c?.sessionsModel === 'v2';
  // His words (2026-10-06), matching the calendar's own box.
  const who = c?.name || 'this client';
  showConfirmDialog({
    message: newRules
      ? `Delete ${who}'s weekly time, ${label}?\n\nTheir sessions from today forward are removed and ${who} is notified.`
      : `Remove ${label}? Sessions already booked stay on the calendar — new weeks stop booking automatically.`,
    okLabel: newRules ? 'Delete the weekly time' : 'Remove Slot',
    onConfirm: async () => {
      try {
        // ⚠️ action:'remove' targets ONE slot by id. `clear:true` (the old
        // call here) wipes every slot the client holds — a client with
        // three would have lost all three from one ✕ (pre-merge review
        // 2026-08-24).
        await callFunction('coach-standing-reservation-set', { clientId, action: 'remove', slotId });
        showToast(newRules ? 'Weekly time deleted.' : 'Standing slot removed.', 'success');
        renderCurrentView();
      } catch (err) {
        showToast(err.message || 'Failed to remove standing slot.', 'error');
      }
    }
  });
}
